import { callExternalApi } from "../../../services/external-api.service";

class TouchpointHttpClient {

    _apiServerUrl;

    constructor(apiServerUrl = process.env.REACT_APP_API_ORIGIN) {
        this._apiServerUrl = `${apiServerUrl}/v2`;
    }

    async getTouchpoints(projectTag: string, accessToken: string) {
        const config = {
            url: `${this._apiServerUrl}/project/${projectTag}/touchpoints`,
            method: "GET",
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        };

        const { data, error } = await callExternalApi({ config });

        return {
            data: data.data || null,
            error,
        };
    }
}

export default TouchpointHttpClient;